'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidIncrementsIfNeeded = exports.getBidIncrementsByItemId = exports.getBidIncrements = exports.LOAD_BID_INCREMENTS_SUCCESS = exports.LOAD_BID_INCREMENTS_REQUEST = exports.LOAD_BID_INCREMENTS_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _item = require('../modules/item');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _catalog = require('../modules/catalog');

var _home = require('../modules/home');

var _similarItems = require('../modules/similarItems');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BID_INCREMENTS_FAIL = exports.LOAD_BID_INCREMENTS_FAIL = 'la/domain/bidIncrements/LOAD_FAIL';
var LOAD_BID_INCREMENTS_REQUEST = exports.LOAD_BID_INCREMENTS_REQUEST = 'la/domain/bidIncrements/LOAD_REQUEST';
var LOAD_BID_INCREMENTS_SUCCESS = exports.LOAD_BID_INCREMENTS_SUCCESS = 'la/domain/bidIncrements/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_BID_INCREMENTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_BID_INCREMENTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_BID_INCREMENTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.catalogId] = item.bidIncrements;
                loaded[item.catalogId] = time;
                loading = (0, _difference2.default)(loading, [item.catalogId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _catalog.LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _similarItems.LOAD_SIMILAR_ITEMS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.bidIncrements) {
                action.payload.bidIncrements.forEach(function (item) {
                    existing[item.catalogId] = [].concat((0, _toConsumableArray3.default)(item.bidIncrements));
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.bidIncrements;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBidIncrements = exports.getBidIncrements = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getBidIncrementsByItemId = exports.getBidIncrementsByItemId = (0, _reselect.createSelector)([byIdSelector, _item.getItem], function (byId, item) {
    return byId[item.catalogId] || [];
});

var getLoadTimeForBidIncrements = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isBidIncrementsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchBidIncrements = (0, _reselect.createSelector)([idSelector, getBidIncrements, getLoadTimeForBidIncrements, isBidIncrementsLoading], function (catalogId, item, loaded, loading) {
    if (!catalogId) return false;
    if (!(0, _isEmpty2.default)(item)) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchBidIncrementsIfNeeded = exports.fetchBidIncrementsIfNeeded = function fetchBidIncrementsIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!shouldFetchBidIncrements(getState(), catalogId)) {
                                _context.next = 16;
                                break;
                            }

                            state = getState();
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 3;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_BID_INCREMENTS_REQUEST
                            });
                            _context.next = 7;
                            return _api.BidIncrements.fetchBidIncrements({ catalogId: catalogId, deployment: deployment });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_BID_INCREMENTS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](3);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_BID_INCREMENTS_FAIL
                            });

                        case 14:
                            _context.next = 17;
                            break;

                        case 16:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[3, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/bidIncrements.js
// module id = /Mrt
// module chunks = 46